import React from 'react';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import { Container } from '@mui/material';
import { RoleName } from '@marageti/z4-sdk/lib/auth';
import { useAuthStore } from '../../../store';
import AuditView from './audit-view';

const AuditContainer: React.FC = () => {
  const location = useLocation();
  const { loggedInTeamMember } = useAuthStore();
  const isAuditHome = location.pathname === '/settings/audit';

  const isAdmin = loggedInTeamMember?.userInfo?.some((info) => info.roles?.includes(RoleName.ADMIN)) || false;

  if (!isAdmin) {
    return <Navigate to="/settings" replace />;
  }

  return (
    <Container maxWidth={isAuditHome ? 'lg' : 'xl'}>
      {isAuditHome ? <AuditView /> : <Outlet />}
    </Container>
  );
};

export default AuditContainer;
